import { render, staticRenderFns } from "./ApplicationFormCompany.vue?vue&type=template&id=54dc6ffd&scoped=true"
import script from "./ApplicationFormCompany.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormCompany.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc6ffd",
  null
  
)

export default component.exports